"use strict";
import { ArrowChangeDown } from "components/Icons/ArrowChangeDown";
import { ArrowChangeUp } from "components/Icons/ArrowChangeUp";
import styled from "lib/styled-components";
import { colorsDark, colorsLight } from "ui/src/theme";
const StyledUpArrow = styled(ArrowChangeUp)`
  color: ${({ theme, $noColor }) => $noColor ? theme.neutral2 : theme.darkMode ? colorsDark.statusSuccess : colorsLight.statusSuccess};
`;
const StyledDownArrow = styled(ArrowChangeDown)`
  color: ${({ theme, $noColor }) => $noColor ? theme.neutral2 : theme.darkMode ? colorsDark.statusCritical : colorsLight.statusCritical};
`;
export function calculateDelta(start, current) {
  return (current / start - 1) * 100;
}
function isValidDelta(delta) {
  return delta !== null && delta !== void 0 && delta !== Infinity && !isNaN(delta);
}
function isDeltaZero(delta) {
  return parseFloat(delta) === 0;
}
export function DeltaArrow({ delta, formattedDelta, noColor = false, size = 16 }) {
  if (!isValidDelta(delta)) {
    return null;
  }
  const isZero = isDeltaZero(formattedDelta);
  return Math.sign(delta) < 0 && !isZero ? <StyledDownArrow width={size} height={size} key="arrow-down" aria-label="down" $noColor={noColor} /> : <StyledUpArrow width={size} height={size} key="arrow-up" aria-label="up" $noColor={noColor} />;
}
export const DeltaText = styled.span`
  color: ${({ theme, delta }) => delta !== void 0 ? Math.sign(delta) < 0 ? theme.darkMode ? colorsDark.statusCritical : colorsLight.statusCritical : theme.darkMode ? colorsDark.statusSuccess : colorsLight.statusSuccess : theme.neutral1};
`;
